export enum DocumentTypeName {

  DocTypeMedicalRecord = 1,
  DocTypeAttestation = 2,
  DocTypeInvoice = 4,
  DocTypeMessage = 6,
  DocTypeDOB = 7,
}
